class SponsorProductDrawer extends HTMLElement {
  static activeInstance = null;

  constructor(position = 'right', size = '566px') {
    super();

    if (!SponsorProductDrawer.activeInstance) {
      this.defaultPosition = position;
      this.defaultSize = size;
      this.createDrawer(position, size);
      SponsorProductDrawer.activeInstance = this;
    }

    return SponsorProductDrawer.activeInstance;
  }

  createDrawer(position, size) {
    this.overlay = document.createElement('div');
    this.overlay.className = 'sponsor-overlay';
    this.overlay.addEventListener('click', () => this.close());

    this.drawer = document.createElement('div');
    this.drawer.className = `sponsor-drawer drawer-${position} drawer-size-${size}`;

    const header = document.createElement('div');
    header.className = 'sponsor-drawer-header';

    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
    `;
    closeBtn.addEventListener('click', () => this.close());

    header.appendChild(closeBtn);

    this.contentArea = document.createElement('div');
    this.contentArea.classList.add('sponsor-drawer-content');
    this.contentArea.innerHTML = `
      <h4 class="sponsor-drawer-content-header">Acerca de este anuncio</h4>
      <p class="sponsor-drawer-content-subheader">¿Cuál es el motivo de que se muestre este anuncio?</p>
      <p>Estás viendo este anuncio por uno o varios de los siguientes motivos:</p>
      <ul>
        <li>Los términos de búsqueda que has utilizado o el contenido o los productos que estás viendo en esta página</li>
        <li>Tu actividad anterior en los sitios web de Farmaciasdirect</li>
      </ul>
      <p class="sponsor-drawer-content-subheader">Acerca del anunciante</p>
      <p id="advertiser-name" style="margin: 0"></p>
      <p id="advertiser-buyer" style="margin: 0"></p>
    `;

    this.drawer.appendChild(header);
    this.drawer.appendChild(this.contentArea);

    document.body.appendChild(this.overlay);
    document.body.appendChild(this.drawer);
  }

  open(advertiserName, paidForBy, { position, size } = {}) {
    position = position || this.defaultPosition;
    size = size || this.defaultSize;

    this.drawer.classList.remove(
      'drawer-bottom', 
      'drawer-left', 
      'drawer-right',
      'drawer-size-xs',
      'drawer-size-sm',
    );
    
    this.drawer.className = `sponsor-drawer drawer-${position} drawer-size-${size}`;

    this.contentArea.querySelector('#advertiser-name').innerHTML = `Nombre del anunciante: ${advertiserName}`;
    this.contentArea.querySelector('#advertiser-buyer').innerHTML = `Quién pagó este anuncio: ${paidForBy}`;

    this.drawer.classList.remove('open');
    this.overlay.classList.remove('active');
    void this.drawer.offsetHeight;

    requestAnimationFrame(() => {
      this.drawer.classList.add('open');
      this.overlay.classList.add('active');
      this.overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
  }

  close() {
    this.drawer.classList.remove('open');
    this.overlay.classList.remove('active');
    this.overlay.style.display = 'none';
    document.body.style.overflow = '';
  }
}

export default SponsorProductDrawer;

if ('customElements' in window) {
	customElements.define('sponsor-product-drawer', SponsorProductDrawer);
}